<template>
  <div>
    <el-row :gutter="10" style="margin-top: 20px;;height: 100%; width: 100% ; text-align:middle">
      <el-col :xl="6" :lg="6" :md="8" :sm="12" :xs="12" style="height: 100%;cursor: pointer;" v-for="item in raceNews"  :key="item.index">
        <div style="height: 100%" @click="toDetail(item.id)">
          <div style="width: 100%; height: 70%;">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.coverUrl"
              :preview-src-list="images">
            </el-image>
          </div>
          <div :title="item.title"
            style="width: 100%; height: 45px;background: #fff;text-align: left;font-size:15px;float:left;overflow: hidden;text-overflow:ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;"
            v-html="item.title"
          ></div>
          <div
            style="width: 100%; height: 15%;background: #fff;text-align: right;font-size:15px;float:left">
            <div style=" display: inline-block;color:#b1b6bb">
              <span :title=item.author> {{item.author.length > 10 ? item.author.slice(0, 10) + '...' : item.author}}</span>
              <i class="el-icon-time"></i>
              {{item.releaseDate}}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
   <!--  <template>
        <pagination
          style="text-align: center"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getRaceNews"
           layout="total,  prev, pager, next, jumper"
        />
      </template> -->
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "Image",
  components: {Pagination},
   props:['articleNews'],
  data() {
    return {
      nameEn: "" ,
      raceNews:[],
      images:[],
      // 总条数
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 0,
      }
    };
  },
  created() {
   this.nameEn = this.articleNews;
    this.getRaceNews();
  },
  methods: {
    getRaceNews() {
      //赛事资讯
      var api = this.siteURL + "/actuator/article/selectArticleList?siteId="+this.siteId+"&nameEn="+this.nameEn+"&pageNum="+this.queryParams.pageNum+"&pageSize="+this.queryParams.pageSize;
      this.axios.get(api, {}).then(response => {
        this.raceNews = response.data.rows;
        this.total = response.data.total
      });
    },
    toDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: { id: e }
      });
      window.open(routeUrl.href, "_blank");
    },
  }
};
</script>

<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// src/views/news.vue